import { AppType } from '@office-start/app-gallery-types';
import { copilotM365AppId } from './constants';
import { getPlatformType, pinApp } from './utils';
export var pinCopilotApp = function (userData, setUserData) {
    var platformType = getPlatformType(AppType.Mos);
    if (userData !== undefined) {
        var newAppBarUserData = pinApp(userData, copilotM365AppId, platformType, 'UserPinned');
        setUserData(newAppBarUserData);
    }
};
//# sourceMappingURL=copilotPinningUtils.js.map